import React from 'react';
import {
  DashedTitle,
  DatePicker,
  Icon,
  Row
} from '@fasstech/middle-design-system';
import { formatCurrency } from '@@viewHelpers/formatCurrency.mjs';
import { mapIndexed } from '@@serverHelpers/index.mjs';
import { dateTsToFr } from '@@viewHelpers/date.js';
import Beneficiaries from '@@views/souscriptionRecap/client/components/Beneficiaries.jsx';

const SummaryDailyBenefit = ({
  pricingLevel,
  getMiddleText,
  effectDate,
  grantees,
  customerCardOptions,
  granteesCardOptions,
  onEditBeneficiaries
}) => {
  const options = [
    {
      label: getMiddleText(
        'NIVEAUXGARANTIESETTARIFS_GARANTIES_CHOIX_NIV_GAR_LABEL'
      ),
      value: formatCurrency(pricingLevel)
    }
  ];

  return (
    <>
      <Beneficiaries
        getMiddleText={getMiddleText}
        grantees={grantees}
        customerCardOptions={customerCardOptions}
        granteesCardOptions={granteesCardOptions}
        onEdit={onEditBeneficiaries}
      />
      <div className="flex flex-col items-center gap-4">
        <Icon name={'circleHospital'} size={50} />
        <DashedTitle>Garanties</DashedTitle>
        <div className={'flex flex-col gap-4 w-full items-start'}>
          <div>
            <DatePicker
              label={getMiddleText('PROCESSDEVENTE_EFFECT_DATE_PLACEHOLDER')}
              value={dateTsToFr(effectDate)}
              disabled={true}
            />
          </div>
          <div className="border border-[#E7E7E7] rounded-md w-full">
            <div
              className={
                'w-full flex justify-start gap-4 items-center p-4 border-b'
              }
            >
              <Icon name={'circleHospital'} size={30} />
              <div
                className={'font-bold'}
              >{`Garantie ${getMiddleText('GENERAL_RISQUE')}`}</div>
            </div>
            <div className={'p-4'}>
              {mapIndexed((item, index) => <Row item={item} index={index} />)(
                options
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SummaryDailyBenefit;
